// extracted by mini-css-extract-plugin
export var marqueeItem = "marquee-module--marquee-item--4ec94";
export var marqueeWrapper = "marquee-module--marquee-wrapper--51229";